// extracted by mini-css-extract-plugin
export default {"item":"FileListItem_item__i2RRw","icon":"FileListItem_icon__KSffJ"};